export const ROOT = 'StepOne/form/job';

export const FETCH_JOB_REQUEST = `${ROOT}/FETCH_JOB_REQUEST`;
export const FETCH_JOB_FAILURE = `${ROOT}/FETCH_JOB_FAILURE`;
export const FETCH_JOB_SUCCESS = `${ROOT}/FETCH_JOB_SUCCESS`;

export const SET_JOB_MESSAGE = `${ROOT}/SET_JOB_MESSAGE`;
export const SET_JOB_SELECTED = `${ROOT}/SET_JOB_SELECTED`;
export const SET_JOB_WORD_FOUND = `${ROOT}/SET_JOB_WORD_FOUND`;

export const CLEAR_JOB_MESSAGE = `${ROOT}/CLEAR_JOB_MESSAGE`;
export const CLEAR_JOB_DATA = `${ROOT}/CLEAR_JOB_DATA`;
export const CLEAR_JOB_SELECTED = `${ROOT}/CLEAR_JOB_SELECTED`;
